import { Group, Stack } from '@mantine/core';
import { Text, Title } from '@repo/foundations';
import { memo, useCallback } from 'react';
import { useIntercomWithDomainCheck } from '../../utils/useIntercomWithDomainCheck';
import { AuthCard } from './AuthCard';
import { AuthButton } from './AuthLayouts/AuthButton';
import { AuthLayoutBase } from './AuthLayouts/AuthLayoutBase';

export function AuthStepWorkspacePending() {
	const { boot, show } = useIntercomWithDomainCheck();

	const handleContactSales = useCallback(async () => {
		await boot();
		show();
	}, [boot, show]);

	return (
		<AuthLayoutBase>
			<AuthCard width={480}>
				<Stack spacing="xl">
					<Stack spacing="md">
						<Title>Workspace Setup Required</Title>
						<Text color="text/secondary/default">
							Your account has been created successfully, but you need a
							workspace to get started.
						</Text>
						<Text color="text/secondary/default">
							Please reach out to our sales team to get your workspace set up
							and start using Secoda.
						</Text>
					</Stack>

					<Stack spacing="md">
						<AuthButton
							variant="primary"
							onClick={handleContactSales}
							style={{ width: '100%' }}
						>
							<Group align="center" position="center">
								Contact Sales
							</Group>
						</AuthButton>
					</Stack>
				</Stack>
			</AuthCard>
		</AuthLayoutBase>
	);
}

export default memo(AuthStepWorkspacePending);
